<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/J54l3W/tc-custom/9781468315929.jpg?1705317489326" alt="This image is the cover for the book Last Man in Europe"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Last Man in Europe
      </h1>
      <p class="bookDescription body article font2">
        <b>This “riveting novel about Orwell’s last days” takes readers inside the renowned author’s mind as he creates his final dystopian masterpiece (<i>New Statesman</i>).</b><br/><br/><i>April, 1947</i>. In a run-down farmhouse on a remote Scottish island, George Orwell begins his last and greatest work,<i> Nineteen Eighty-Four</i>. Forty-three years old and suffering from the tuberculosis that within three winters will take his life, Orwell comes to see the book as his legacy—the culmination of a career spent fighting to preserve the freedoms which the wars and upheavals of the twentieth century have threatened. Completing the book is an urgent challenge, a race against death.<br/><br/>In this masterful novel, Dennis Glover explores the creation of Orwell’s classic work which defined the twentieth century for millions of readers worldwide—and has continued to prove its unnerving relevance in the twenty-first. Simultaneously a captivating drama, a unique literary excavation, and an unflinching portrait of a writer, <i>The Last Man in Europe</i> will change the way we understand both our enduringly Orwellian times and Orwell’s timeless masterpiece.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Dennis Glover
      </h2>
      
      <p class="authorDescription body article">Dennis Glover earned his PhD in history from King’s College, Cambridge. He has worked for two decades as an academic, newspaper columnist, political adviser, and speechwriter. He is the author of The Art of Great Speeches, Orwell’s Australia, and The Economy is Not a Society. The Last Man in Europe is his first novel.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      The Overlook Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?79fd5a85